import { FormEvent, useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { defineValueInInput } from "../../../../../components/funcForInput";
import removeAllErrorMsg from "../../../../../components/funcRemoveAllErros";
import { ApiEndpoints, reqGetNew } from "../../../../../config/apiClient";
import { getCookie } from "../../../../../config/cookies";

export default function ModalImportarXML({ show, handleClose, handleUpdate }: iProps) { 
    const [loading, setLoading] = useState<boolean>(false)
    const [empresas, setEmpresas] = useState<any[]>([])
    
    useEffect(() => {
        const getDados = async () => {
            setLoading(true)
            const api = await reqGetNew(ApiEndpoints.nfEmpresasInfosNFSe)
            if (api.status === 200) {
                setEmpresas(api.data)
                console.log(api.data)
            }
            setLoading(false)
        }
        getDados()
    }, [])
    
    function handleSubmit(event: FormEvent<HTMLFormElement>) { 
        event.preventDefault()
        event.stopPropagation()

        removeAllErrorMsg()

        const form:any = event.target
        let formValidado = true

        let dadosImportar = {
            xml: form.xml.files,
            id_empresa: Number(form.id_empresa.value),
        }
        console.log(dadosImportar)
        
        if (dadosImportar.id_empresa === 0) { 
            form.id_empresa.nextElementSibling.style.display = "block"
            formValidado = false
        }
        
        if (dadosImportar.xml.length === 0) {
            form.xml.nextElementSibling.style.display = "block"
            formValidado = false
        }

        if (!formValidado) {
            return
        }

        importar(dadosImportar)
    }
    
    async function importar(dadosImportar:any) {
        setLoading(true)

        const token = getCookie("token")
        const id_usuario = getCookie("id_user")
        let dados = new FormData()
        dados.append('xml', dadosImportar.xml[0])
        dados.append('id_empresa', dadosImportar.id_empresa)

        try {
            let api:Response
            let apiData = await fetch(
                ApiEndpoints.nfseImportarXML.endpoint,
                {
                    method: "POST",
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "id_usuario": id_usuario,
                    },
                    body: dados
                }
            ).then(response => {
                api = response
                return response.json()
            })
            if (api!.status === 200) {
                toast.success("XML importado com sucesso!", {
                    containerId: 1,
                    position: 'top-center',
                    theme: 'dark'
                })
                defineValueInInput("xml", "")
                defineValueInInput("id_empresa", "0")
                handleUpdate()
            } else {
                toast.warn(String(apiData.message), {
                    containerId: 1,
                    position: 'top-center',
                    theme: 'dark'
                })
            }
        } catch (error) {
            console.log(error)
            toast.warn('Não foi possível importar, verifique se o layout está correto ou contate o suporte!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
        }

        setLoading(false)
    }
    
    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size="lg"
        >
            <Modal.Header closeButton>
                <Modal.Title>Importar XML</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form id={`formImportarXml`} onSubmit={handleSubmit} noValidate>
                    <Row>
                        <Col className='col-6'>
                            <Form.Group>
                                <Form.Label>Empresa:</Form.Label>
                                <Form.Select name="id_empresa" id="id_empresa" aria-label="Selecione o opção">
                                    <option value="0">Não Selecionado</option>
                                    { 
                                        empresas.map((dados, idx, arr) => { 
                                            return (
                                                <option value={dados.empresa.id_empresa} key={idx}>{dados.empresa.nome}</option>
                                            )
                                        })
                                    }
                                </Form.Select>
                                <Form.Control.Feedback type="invalid">
                                    Informe a Empresa!
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col className="col-6">
                            <Form.Group>
                                <Form.Label>Arquivo XML:</Form.Label>
                                <Form.Control type="file" name="xml" id="xml" aria-label="Selecione o XML" accept=".xml"></Form.Control>
                                <Form.Control.Feedback type="invalid">
                                    Selecione o arquivo!
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>
                    <br/>
                    <Button type="submit" disabled={loading} style={{marginRight: "10px"}}>{loading ? "Aguarde..." : "Importar"}</Button>
                </Form>
                <br></br>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>Fechar</Button>
            </Modal.Footer>
        </Modal>
    )
}

interface iProps { 
    show: boolean
    handleClose: any,
    handleUpdate: any,
}
